import { useContext } from "react";

import LanguageContext from "context/language/languageContext";
import { TELTONIKA_IOT_GROUP_WEBSITE } from "shared/constants/externalLinks";
import { isLithuanianLanguage } from "shared/functions";

export const useTranslatedExternalLinks = () => {
    const { language } = useContext(LanguageContext);

    const isLtLanguage = isLithuanianLanguage(language);

    const SUBFOLDER = isLtLanguage ? "lt/" : "";
    const POLICIES_CERTIFICATE_PATH = "policies-certificates/";

    const directory = `${SUBFOLDER}${POLICIES_CERTIFICATE_PATH}`;
    const url = `${TELTONIKA_IOT_GROUP_WEBSITE}${directory}`;

    const COOKIES_POLICY_RESOURCE = "cookies-policy";
    const DATA_PROCESSING_AGREEMENT_RESOURCE = "data-proccesing-agreement";
    const PRIVACY_POLICY_RESOURCE = "privacy-policy";
    const TERMS_OF_SERVICE_RESOURCE = "teltonika-terms-of-service";

    const cookiesPolicy = `${url}${COOKIES_POLICY_RESOURCE}`;
    const dataProcessingAgreement = `${url}${DATA_PROCESSING_AGREEMENT_RESOURCE}`;
    const privacyPolicy = `${url}${PRIVACY_POLICY_RESOURCE}`;
    const termsOfService = `${url}${TERMS_OF_SERVICE_RESOURCE}`;

    return {
        cookiesPolicy,
        dataProcessingAgreement,
        privacyPolicy,
        termsOfService
    };
};
